<nav class="navbar navbar-expand-lg bg-white border-bottom">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/">
      <img src="assets/img/favicon.png" alt="" width="24" height="24" class="d-inline-block align-text-top"/>
      {{ 'app.top.menu.brand' | translate }}
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText"
            aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarText">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item" *ngIf="apiService.isAuthorized()">
          <a class="nav-link" routerLink="/dashboard" translate>app.top.menu.dashboard</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/documentation" translate>app.top.menu.documentation</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/use" translate>app.top.menu.use</a>
        </li>
      </ul>
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li *ngIf="apiService.isAuthorized()">
          <div class="dropdown">
            <a href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <span class="icon icon24 notification mx-2"></span>
            </a>
            <ul class="dropdown-menu dropdown-menu-end" style="font-size: 12px; width: 400px">
              <li>
                <span class="fw-bold">Title</span>
                <p>Message</p>
              </li>
            </ul>
          </div>
        </li>
        <li *ngIf="apiService.isAnonymous()" class="nav-item">
          <a class="nav-link" routerLink="/sign-up" translate>app.top.menu.register</a>
        </li>
        <li *ngIf="apiService.isAnonymous()" class="nav-item">
          <a class="nav-link" routerLink="/sign-in" translate>app.top.menu.login</a>
        </li>

        <li *ngIf="apiService.isAuthorized()" class="nav-item">
          <div class="dropdown">
            <a href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ userService.getCurrentUser().displayName }}
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <a class="dropdown-item" routerLink="/profile" translate>app.top.menu.profile</a>
              </li>
              <li>
                <hr class="dropdown-divider"/>
              </li>
              <li>
                <a class="dropdown-item" (click)="apiService.signOut()" translate>app.top.menu.logout</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
